<template>
  <div class="container">
    <div class="before-you-go-container">
      <span class="before-you-go">
        Before you go, consider these special offers:
      </span>
    </div>
    <div class="row">
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>Switch to Annual For A Discounted Price</label>
          </div>
          <div class="cancellation-options-body most-popular">
            <div class="insider-most-popular">
              <p class="most-popular-text">MOST POPULAR</p>
            </div>
            <ul class="cancellation-options-list">
              <li>
                Switch to an annual plan and receive your new 1-year
                subscription for ${{ unsubscribe_promo_price }}
              </li>
              <li>${{ price }} for following years</li>
            </ul>
          </div>
          <div class="cancellation-submit">
            <a
              v-bind:class="
                has_used_datacast_essentials_promo
                  ? 'button-grey'
                  : 'button-green'
              "
              v-on:click="annualSubscription"
            >
              PURCHASE ANNUAL
            </a>
          </div>
        </div>
      </div>
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>Temporarily Pause Your Subscription</label>
          </div>
          <div class="cancellation-options-body">
            <ul class="cancellation-options-list">
              <li>Pause subscription for 30 or 60 days</li>
              <li>You will not be billed while subscription is paused</li>
              <li>
                Regular monthly billing resumes automatically when the paused
                period is over
              </li>
            </ul>
          </div>
          <div class="cancellation-submit">
            <a
              class="button-green button-green-thirty button-margin"
              v-on:click="thirtyDayPause"
            >
              30-DAYS
            </a>
            <a class="button-green button-margin" v-on:click="sixtyDayPause">
              60-DAYS
            </a>
          </div>
        </div>
      </div>
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>
              Understand Economic Trends for Less with the ITR insider™
            </label>
          </div>
          <div class="cancellation-options-body-dce">
            <ul class="cancellation-options-list">
              <li>Unsubscribe from DataCast Essentials subscription</li>
              <li>
                Sign up for the
                <a target="_blank" href="/insider">ITR Insider subscription</a>
                at the low cost of ${{ insider_price }}/month
              </li>
              <li>Receive first month for ${{ insider_promo_price }}!</li>
            </ul>
          </div>
          <div class="cancellation-submit">
            <a
              v-bind:class="has_insider ? 'button-grey' : 'button-green'"
              v-on:click="switchToInsider"
            >
              SWITCH TO INSIDER
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'DataCastEssentialsCancellationOptionsComponent',
    props: {
      product_to_unsubscribe: {
        type: String,
        required: true,
      },
      unsubscribe_promo_price: {
        type: Number,
        required: true,
      },
      price: {
        type: Number,
        required: true,
      },
      insider_price: {
        type: Number,
        required: true,
      },
      insider_promo_price: {
        type: Number,
        required: true,
      },
      has_insider: {
        type: Boolean,
        required: true,
      },
      has_used_datacast_essentials_promo: {
        type: Boolean,
        required: true,
      },
    },
    data: function () {
      return {
        iAgreeChecked: false,
      };
    },
    methods: {
      annualSubscription: function () {
        if (!this.has_used_datacast_essentials_promo) {
          axios
            .post(
              '/dashboard/cancelation/options/' + this.product_to_unsubscribe
            )
            .then(function (response) {
              window.location.href =
                '/dashboard/datacast-essentials-annual-subscription/';
            })
            .catch(function (error) {
              window.location.href = '/dashboard/contact-customer-care-error/';
            });
        }
      },
      thirtyDayPause: function () {
        axios
          .post(
            '/dashboard/cancelation/options/pause/' +
              this.product_to_unsubscribe +
              '/' +
              30
          )
          .then(function (response) {
            window.location.href =
              '/dashboard/cancelation/options/pause/datacast-essentials/30';
          })
          .catch(function (error) {
            window.location.href = '/dashboard/contact-customer-care-error/';
          });
      },
      sixtyDayPause: function () {
        axios
          .post(
            '/dashboard/cancelation/options/pause/' +
              this.product_to_unsubscribe +
              '/' +
              60
          )
          .then(function (response) {
            window.location.href =
              '/dashboard/cancelation/options/pause/datacast-essentials/60';
          })
          .catch(function (error) {
            window.location.href = '/dashboard/contact-customer-care-error/';
          });
      },
      switchToInsider: function () {
        if (!this.has_insider) {
          axios
            .post(
              '/dashboard/cancelation/options/switch-to-insider/' +
                this.product_to_unsubscribe
            )
            .then(function (response) {
              window.location.href =
                '/dashboard/cancelation/options/switch-to-insider/' +
                this.product_to_unsubscribe;
            })
            .catch(function (error) {
              window.location.href = '/dashboard/contact-customer-care-error/';
            });
        }
      },
    },
  };
</script>
